import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';
import cn from 'classnames';

export type TableRow = TParentComponentProps & {
  message?: boolean;
  flexSm?: boolean;
  disabled?: boolean;
};

export const TableRow: FunctionComponent<TParentComponentProps> = ({
  message,
  flexSm,
  className,
  disabled,
  ...props
}) => {
  const componentClassName = cn({
    'cart-table__row--message': !!message,
    'cart-table__row--flex-sm': !!flexSm,
    'cart-table__row--disabled': !!disabled,
    [className]: !!className,
  });

  return <ParentComponent className={componentClassName} {...props} />;
};

TableRow.defaultProps = {
  defaultClassName: 'cart-table__row',
  as: 'tr',
  message: false,
};

export default TableRow;
